import React from 'react';

const hasValue = (value) => typeof value === 'string' && value.trim().length > 0;

const EntryLine = ({ label, value, url }) => {
  if (!hasValue(value)) {
    return (
      <p>
        <strong>{label}:</strong> TODO
      </p>
    );
  }

  return (
    <p>
      <strong>{label}:</strong> {value}
      {hasValue(url) && (
        <>
          {' '}
          <a href={url} target="_blank" rel="noreferrer">
            Open
          </a>
        </>
      )}
    </p>
  );
};

const AttributionsRenderer = ({ data }) => {
  if (!data || !Array.isArray(data.categories) || data.categories.length === 0) {
    return <p>No attribution entries found.</p>;
  }

  return (
    <div className="attributions-root">
      {data.categories.map((category) => (
        <section key={category.category} className="attribution-category">
          <h3>{category.category}</h3>
          <div className="attribution-entry-list">
            {(category.entries || []).map((entry, index) => (
              <article key={`${category.category}-${entry.title || index}`} className="attribution-entry-card">
                <EntryLine label="Title" value={entry.title} />
                <EntryLine label="Author" value={entry.creator} />
                {hasValue(entry.location) && <EntryLine label="Location" value={entry.location} />}
                <EntryLine label="Source" value={entry.sourceUrl} url={entry.sourceUrl} />
                <EntryLine label="License" value={entry.licenseName} url={entry.licenseUrl} />
                {hasValue(entry.copyrightNotice) && (
                  <p>
                    <strong>Copyright:</strong> {entry.copyrightNotice}
                  </p>
                )}
                {hasValue(entry.modified) && (
                  <p>
                    <strong>Modified:</strong> {entry.modified}
                  </p>
                )}
                {hasValue(entry.notes) && (
                  <p>
                    <strong>Notes:</strong> {entry.notes}
                  </p>
                )}
              </article>
            ))}
          </div>
        </section>
      ))}
    </div>
  );
};

export default AttributionsRenderer;
